import React from "react";
import {
    TitleWrapper,
    TitleText,
} from "../../../shared/styled/TitleBar";

const Title = () => {
    return (
        <TitleWrapper>
            <TitleText>Nhập dữ liệu</TitleText>
        </TitleWrapper>
    );
};

export default Title;

